import { Grid, Tooltip, useMediaQuery } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import ConfirmPopup from "app/common/Component/Popup/ConfirmPopup";
import IconDelete from "app/common/Icon/IconDelete";
import IconPen from "app/common/Icon/IconPen";
import { HISTORY_TAB } from "app/common/LocalConst";
import {
  formatMoney,
  getDateTime,
  isRoleChiefTechician,
  isRoleHisReadOnly,
  isRoleTechician,
} from "app/common/LocalFunction";
import { useStore } from "app/stores";
import { observer } from "mobx-react";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import RegisterTreatmentPlanPopupTotalItem from "../RegisterServiceTreatmentPlanTab/Popup/RegisterTreatmentPlanPopupTotalItem";
const ListTreatmentPlanBlock = ({
  initialPatient,
  setCurrentTab,
  handleAfterSubmit,
}) => {
  const { listVatPercent, customerSourceWalkIn } =
    useStore().patientManagementStore.patientGeneralStore;
  const { t } = useTranslation();
  const {
    openCreateOrEditTreatmentPlanPopup,
    handleOpenCreateOrEditTreatmentPlanPopup,
    handleCloseCreateOrEditServicePopup,
    saveOrUpdateRegisterService,
    initRegisterTreatmentPlan,
    openConfirmDelete,
    handleDeleteTreatmentPlanCard,
    handleOpenConfirmDelete,
  } = useStore().patientManagementStore.registerTreatmentPlanStore;
  const isRoleCt = isRoleTechician() || isRoleChiefTechician();
  const isReadonly = isRoleHisReadOnly();
  const isMobile = useMediaQuery("(max-width:768px)");
  return (
    <div
      style={{
        backgroundColor: "aliceblue",
        height: "100%",
        boxShadow: "0 8px 24px rgba(0, 0, 0, 0.08)",
      }}
    >
      <Grid
        container
        spacing={1}
        className="m-0 w-100"
        style={{ backgroundColor: "aliceblue" }}
      >
        <Grid item xs={12} className="search-title-card">
          <p className="title-block">Liệu trình</p>
          <div className="flex align-center flex-end gap-1 cursor">
            {!isRoleCt && (
              <p
                className="button-more"
                onClick={() => setCurrentTab(HISTORY_TAB)}
              >
                Xem thêm
              </p>
            )}
          </div>
        </Grid>

        <Grid item xs={12}>
          {(initialPatient?.treatmentList || []).length > 0 ? (
            <div
              style={{
                maxHeight: "400px",
                overflowY: "auto",
                paddingRight: 8,
              }}
              className="custom-scrollbar"
            >
              {(initialPatient?.treatmentList || []).map((row, index) => (
                <Grid
                  key={index}
                  item
                  xs={12}
                  style={{
                    borderBottom: "1px solid gray",
                    padding: "5px",
                    fontSize: "var(--fs-base)",
                  }}
                >
                  <div className="medical-container">
                    <div className="text-medical-container">
                      <div>
                        <span className="text-medical">
                          {getDateTime(row?.startDate)}
                          {row?.endDate ? ` - ${getDateTime(row.endDate)}` : ""}
                        </span>
                      </div>
                      <div className="flex flex-wrap items-center">
                        <span className="name-medical">
                          {row?.clientCard?.name || "Tên thẻ liệu trình"}(
                          {formatMoney(row?.price)})
                        </span>

                        <span className="text-gray-400">|</span>
                        <div className="flex justify-center items-center">
                          <span>Số lượng:</span>
                          <CloseIcon fontSize="inherit" />
                          <span className="value-medical">{row?.quantity}</span>
                        </div>
                      </div>
                      <div>
                        {row?.staffRevenues?.length > 0 && (
                          <span style={{ fontSize: "12px", color: "#666" }}>
                            Nhân viên:
                            <b style={{ marginLeft: 4 }}>
                              {(() => {
                                const seen = new Set();
                                const uniqueStaffs = row.staffRevenues
                                  .filter((s) => {
                                    const id = s.staff?.id;
                                    if (!id || seen.has(id)) return false;
                                    seen.add(id);
                                    return true;
                                  })
                                  .map(
                                    (s) =>
                                      `${s.staff?.staffName} (${s.staff?.code})`
                                  );
                                return uniqueStaffs.join(", ");
                              })()}
                            </b>
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="flex justify-center items-center gap-2 p-2">
                      {!isRoleCt ||
                        (!isReadonly && (
                          <>
                            <Tooltip title="Chỉnh sửa">
                              <div
                                className="flex"
                                onClick={() => {
                                  handleOpenCreateOrEditTreatmentPlanPopup(row);
                                }}
                              >
                                <IconPen />
                              </div>
                            </Tooltip>
                            <Tooltip title="Xóa thẻ liệu trình">
                              <div
                                className="flex"
                                onClick={() => {
                                  handleOpenConfirmDelete(row?.id);
                                }}
                              >
                                <IconDelete />
                              </div>
                            </Tooltip>
                          </>
                        ))}
                    </div>
                  </div>
                  <div className="flex mt-2">
                    <div>
                      Đã thu:{" "}
                      <b style={{ color: "green" }}>
                        {formatMoney(row?.totalBillPatientPaid || 0)}
                      </b>
                    </div>
                    <span className="mx-2 text-gray-400">|</span>
                    <div>
                      Cần thu:{" "}
                      <b style={{ color: "red" }}>
                        {formatMoney(
                          (row.amountActuallyPaid =
                            (+row.price || 0) * (+row.quantity || 0) -
                            (+row.discount || 0) +
                            (+row.taxTotal || 0))
                        )}
                      </b>
                    </div>
                  </div>
                  {(() => {
                    let indexSTT = 1;

                    return (
                      <>
                        {/* chỗ nàynày view paServiceRegister */}
                        {(row?.paServiceRegister || []).map(
                          (serviceItem, serviceIndex) => (
                            <div
                              className="flex mb-2 mt-2"
                              style={{
                                fontSize: "var(--fs-base-two)",
                                flexDirection: "column",
                                borderBottom: "1px solid gray",
                                width: isMobile ? "100%" : "60%",
                              }}
                            >
                              <div className="flex items-center">
                                {indexSTT++}.
                                <span>
                                  {serviceItem?.service?.name || "Tên dịch vụ"}
                                </span>
                                <CloseIcon fontSize="inherit" />
                                <span className="value-medical">
                                  {serviceItem?.quantity || 1}
                                </span>
                                <span className="mx-2 text-gray-400">|</span>
                                <div>
                                  Điều trị:{" "}
                                  <b>{serviceItem?.totalPerformedTimes || 0}</b>
                                  {!serviceItem?.unLimited && (
                                    <>
                                      <span className="mx-1">|</span>
                                      <b style={{ color: "red" }}>
                                        {serviceItem?.totalTreatmentTimes || 0}
                                      </b>
                                    </>
                                  )}
                                </div>
                                {serviceItem?.unLimited && (
                                  <>
                                    <span className="mx-1">|</span>
                                    <Tooltip title="Không giới hạn">
                                      <span className="unlimited-badge">
                                        ♾️
                                      </span>
                                    </Tooltip>
                                  </>
                                )}
                              </div>
                              <div
                                className="flex"
                                style={{
                                  fontSize: "var(--fs-base-two)",
                                  color: "#333",
                                  width: "100%",
                                  marginTop: 4,
                                }}
                              >
                                <Tooltip title="Đã thu">
                                  <div>
                                    <b style={{ color: "green" }}>
                                      {formatMoney(
                                        serviceItem?.totalBillPatientPaid || 0
                                      )}
                                    </b>
                                  </div>
                                </Tooltip>
                                <span className="mx-1">|</span>
                                <Tooltip title="Cần thu">
                                  <div>
                                    <b style={{ color: "red" }}>
                                      {formatMoney(
                                        serviceItem?.amountActuallyPaid
                                      )}
                                    </b>
                                  </div>
                                </Tooltip>
                              </div>
                            </div>
                          )
                        )}

                        {(row?.drugs || []).map((sdrugsItem, drugsIndex) => (
                          <div
                            className="flex mb-2 mt-2"
                            style={{
                              fontSize: "var(--fs-base-two)",
                              flexDirection: "column",
                              borderBottom: "1px solid gray",
                              width: isMobile ? "100%" : "60%",
                            }}
                          >
                            <div className="flex items-center">
                              {indexSTT++}.
                              <span>
                                {sdrugsItem?.drugName || "Tên sản phẩm"}
                              </span>
                              <CloseIcon fontSize="inherit" />
                              <span className="value-medical">
                                {sdrugsItem?.quantity || 1}
                              </span>
                            </div>
                            <div
                              className="flex"
                              style={{
                                fontSize: "var(--fs-base-two)",
                                color: "#333",
                                width: "100%",
                                marginTop: 4,
                              }}
                            >
                              <Tooltip title="Cần thu">
                                <div>
                                  <b style={{ color: "red" }}>
                                    {formatMoney(
                                      sdrugsItem?.amountActuallyPaid
                                    )}
                                  </b>
                                </div>
                              </Tooltip>
                              <span className="mx-1">|</span>
                              <Tooltip title="Đã thu">
                                <div>
                                  <b style={{ color: "green" }}>
                                    {formatMoney(
                                      sdrugsItem?.totalBillPatientPaid || 0
                                    )}
                                  </b>
                                </div>
                              </Tooltip>
                            </div>
                          </div>
                        ))}
                      </>
                    );
                  })()}
                </Grid>
              ))}
            </div>
          ) : (
            <div className="flex justify-center items-center w-full mt-5">
              Chưa có dữ liệu
            </div>
          )}
        </Grid>
        {!!openCreateOrEditTreatmentPlanPopup && (
          <RegisterTreatmentPlanPopupTotalItem
            open={!!openCreateOrEditTreatmentPlanPopup}
            handleClose={handleCloseCreateOrEditServicePopup}
            onSubmit={async (values) => {
              await saveOrUpdateRegisterService(values);
            }}
            handleAfterSubmit={handleAfterSubmit}
            initRegisterTreatmentPlan={{
              ...initRegisterTreatmentPlan,
              patientId: initialPatient?.patientInfo?.id,
            }}
            patient={initialPatient?.patientInfo}
            listVatPercent={listVatPercent}
            customerSourceWalkIn={customerSourceWalkIn}
          />
        )}
        {openConfirmDelete && (
          <ConfirmPopup
            open={openConfirmDelete}
            onClose={() => handleOpenConfirmDelete(null)}
            text="Bạn có chắc chắn muốn hủy thẻ liệu trình này không ?"
            onConfirm={async () => {
              await handleDeleteTreatmentPlanCard();
              handleAfterSubmit();
            }}
          />
        )}
      </Grid>
    </div>
  );
};

export default memo(observer(ListTreatmentPlanBlock));
